<template>
  <div v-show="options && options.length > 1" class="new-selector-layout">
    <div>
      <transition name="fade">
        <Overlay
          :visible="showExplainPhoneType"
          @close="showExplainPhoneType = false"
        />
      </transition>
      <transition name="fade">
        <explain-phone-type-modal
          v-if="showExplainPhoneType"
          @closeModal="showExplainPhoneType = false"
        />
      </transition>
    </div>
    <transition name="fade">
      <Overlay
        :visible="showConfirmDeviceModal"
        :z-index="103"
        @close="showConfirmDeviceModal = false"
      />
    </transition>
    <transition name="slide">
      <confirm-device-modal
        v-if="showConfirmDeviceModal"
        :selected-device="selectedDevice"
        :selected-brand="selectedBrand"
        :related-description="relatedDescription"
        @closeConfirmDeviceModal="showConfirmDeviceModal = false"
        @confirmDeviceModal="showConfirmDeviceModal = false"
        @returnToSelectDevice="returnToSelectDevice"
        @showExplainPhoneType="showExplainPhoneType = true"
      />
    </transition>
    <transition name="fade">
      <div
        v-if="showNewDeviceSelector"
        class="new-selector-layout__overlay"
        @click="closeNewDeviceSelector"
    /></transition>
    <transition name="fade">
      <div v-if="showNewDeviceSelector" class="new-selector-layout__selector">
        <div class="new-selector-layot__selector__back">
          <a
            v-if="selectedBrand"
            href="#"
            class="new-selector-layout__selector__back__link"
            @click.prevent="backToBrands"
          >
            <icon-arrow-left />
            <b>{{ $t('product_form.select_other_brand') }}</b>
          </a>
        </div>
        <div class="new-selector-layout__selector__header">
          <h3>
            {{
              selectedBrand
                ? $t('product_form.select_device')
                : $t('product_form.select_brand')
            }}
          </h3>
        </div>
        <div class="new-selector-layout__search">
          <input
            v-if="selectedBrand"
            v-model="queryDevice"
            class="new-selector-layout__search__input"
            type="text"
            :placeholder="$t('product_form.search_a_device')"
            @input="searchDevice"
            @focus="searchDevice"
          />
          <span v-if="selectedBrand" class="new-selector-layout__search__icon"
            ><icon-search
          /></span>
        </div>
        <div class="new-selector-layout__selector__body">
          <div
            v-if="selectedBrand && !filteredOptions.length"
            class="new-selector-layout__empty"
          >
            <p>
              {{ $t('device_not_found_1') }}
            </p>
            <p>
              {{ $t('device_not_found_2') }}
              <a
                href="https://www.gocase.com.br/abaixo-assinado"
                target="_blank"
                >{{ $t('device_not_found_3') }}</a
              >
            </p>
          </div>
          <ul class="new-selector-layout__list">
            <li
              v-for="device in selectedBrand ? filteredOptions : adaptedBrands"
              :key="device.id"
              :data-slug="device.slug"
              :data-position="device.position"
              :class="[
                'new-selector-layout__item',
                {
                  'new-selector-layout__item--active': inputValue === device.id,
                  'new-selector-layout__item--without-stock': deviceWithoutStock(
                    device
                  ),
                },
              ]"
              @click="
                selectedBrand
                  ? deviceWithoutStock(device)
                    ? () => ({})
                    : selectNewDevice(device)
                  : (selectedBrand = device)
              "
            >
              {{ device.name }}
            </li>
          </ul>
        </div>
        <div class="new-selector-layout__footer">
          <button
            class="new-selector-layout__back"
            @click="closeNewDeviceSelector"
          >
            {{ $t('close') }}
          </button>
        </div>
      </div></transition
    >
    <div
      :class="[
        'new-selector-layout__brands',
        {
          'new-selector-layoyt__brands--mobile': $device.isMobile,
        },
      ]"
    >
      <button
        v-for="brand in adaptedBrands"
        :key="brand.name"
        :class="[
          'new-selector-layout__brand',
          {
            'new-selector-layout__brand--active':
              (selectedBrand && selectedBrand.name) === brand.name,
          },
        ]"
        @click="selectBrand(brand)"
      >
        {{ brand.name }}
      </button>
    </div>
    <button
      class="new-selector-layout__start pretty-select"
      @click="showNewDeviceSelector = true"
    >
      {{
        selectedDevice ? selectedDevice.name : $t('product_form.select_device')
      }}
    </button>
  </div>
</template>

<script>
import Overlay from '~/components/overlay/Overlay.vue'
import IconSearch from '~/components/icons/magnifier/Magnifier'
import IconArrowLeft from '~/components/icons/arrow-left/ArrowLeft'
import ExplainPhoneTypeModal from '~/components/ExplainPhoneTypeModal.vue'
import ConfirmDeviceModal from '~/components/ConfirmDeviceModal.vue'
import pushDataLayer from '~/mixins/gtm/push-data-layer'

export default {
  components: {
    Overlay,
    IconSearch,
    IconArrowLeft,
    ExplainPhoneTypeModal,
    ConfirmDeviceModal,
  },
  mixins: [pushDataLayer],
  props: {
    selectedDevice: {
      type: Object,
      default: null,
    },
    productStock: {
      type: Object,
      default: null,
    },
    caseDeviceId: {
      type: Number,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    brands: {
      type: Array,
      default: () => [],
    },
    restoredFromVuex: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValue: null,
      filteredOptions: [],
      showNewDeviceSelector: false,
      queryDevice: '',
      selectedBrand: null,
      adaptedBrands: [],
      adaptedDevices: [],
      lastInputValue: null,
      showConfirmDeviceModal: false,
      showExplainPhoneType: false,
    }
  },
  computed: {
    shouldShowConfirmDeviceModal() {
      return this.$isBrStore && !!this.relatedDescription
    },
    devicesData() {
      return this.$store.getters['devices/getDeviceData']
    },
    relatedDescription() {
      const device = this.devicesData.find(
        (d) => d.id === this.selectedDevice?.id
      )
      // eslint-disable-next-line camelcase
      return device ? device.related_devices_description : null
    },
    isCase() {
      return this.$store.state.product.product.product_type_code === 'case'
    },
  },

  watch: {
    selectedBrand(brand) {
      if (brand) {
        this.queryDevice = ''
        this.filterDevicesByBrand(brand)
        this.selectDeviceWhenOnlyOneOption()
      }
    },
    showNewDeviceSelector(show) {
      if (!show && !this.selectedBrand) {
        this.setDefaultBrandAndDevice(this.lastInputValue)
      }
    },
    inputValue(inputValue) {
      if (inputValue) this.lastInputValue = inputValue
    },
    selectedDevice(device) {
      this.sendChangedDeviceEventToGtm(device)
      this.showConfirmDeviceModal = this.shouldShowConfirmDeviceModal
    },
    devicesData() {
      this.showConfirmDeviceModal = this.shouldShowConfirmDeviceModal
    },
    restoredFromVuex: {
      handler(val) {
        if (val && this.selectedDevice) {
          this.inputValue = this.selectedDevice.id
          this.selectedBrand = this.adaptedBrands.find(
            (brand) => brand.name === this.selectedDevice.brand
          )
          this.filterDevicesByBrand(this.selectedBrand)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.adaptedBrands =
      this.brands?.map((brand) => ({
        name: brand,
        id: brand,
      })) || []
    if (this.selectedDevice && this.isCase) {
      this.setDefaultBrandAndDevice(this.searchDevice.id)

      this.$store.commit('deviceSelect/setSelectedDevice', {
        name: this.selectedDevice.name,
        brand: this.selectedDevice.brand,
      })
    }
  },
  methods: {
    closeNewDeviceSelector() {
      this.showNewDeviceSelector = false

      if (!this.selectedDevice) {
        this.resetSelectedBrand()
      }
    },
    resetSelectedBrand() {
      this.selectedBrand = null
    },
    sendChangedDeviceEventToGtm(device) {
      this.pushDataLayer({
        event: 'genericEvent',
        eventCategory: 'navigation',
        eventAction: 'changedDevice',
        eventValue: {
          device: device?.name,
          brand: this.selectedBrand?.name,
        },
      })
    },
    setDefaultBrandAndDevice(deviceId) {
      const device = this.options.find((op) => op.id === deviceId)
      if (device) {
        this.selectedBrand = this.adaptedBrands.find(
          (brand) => brand.name === device.brand
        )
        this.filterDevicesByBrand(this.selectedBrand)
      }
    },
    returnToSelectDevice() {
      this.showConfirmDeviceModal = false
      this.showNewDeviceSelector = true
      this.$emit('resetSelectedDevice')
      this.lastInputValue = null
    },
    selectNewDevice(device) {
      this.inputValue = device.id
      this.updateDevice()
      this.$store.commit('deviceSelect/setSelectedDevice', {
        name: device.name,
        brand: device.brand,
      })
    },
    backToBrands() {
      this.selectedBrand = null
      this.inputValue = null
    },
    selectBrand(brand) {
      this.selectedBrand = brand
      this.showNewDeviceSelector = true
    },
    filterDevicesByBrand(brand) {
      this.adaptedDevices = this.options.filter(
        (device) => device.brand === brand.name
      )

      const sortedOptions = JSON.parse(
        JSON.stringify(this.adaptedDevices)
      ).sort((a, b) => (a.position > b.position ? 1 : -1))

      if (this.selectedBrand.name.match('iPhone')) {
        const orderMap = {
          iphone15promax: 0,
          iphone15pro: 1,
          iphone15plus: 2,
          iphone15: 3,
          iphone14promax: 4,
          iphone14pro: 5,
          iphone14plus: 6,
          iphone14: 7,
          iphonese2022: 8,
          iphone13promax: 9,
          iphone13pro: 10,
          iphone13mini: 11,
          iphone13: 12,
          iphone12promax: 13,
          iphone12pro: 14,
          iphone12: 15,
          iphone12mini: 16,
          iphonese2020: 17,
          iphone11promax: 18,
          iphone11pro: 18,
          iphone11: 19,
          iphonex: 20,
          iphonexr: 21,
          iphonexsmax: 22,
          iphone8plus: 23,
          iphone8: 24,
          iphone7plus: 25,
          iphone7: 26,
          iphone6plus: 27,
          iphone6: 28,
        }

        const compareByLaunchOrder = (a, b) => {
          const orderA = orderMap[a.code] || -1
          const orderB = orderMap[b.code] || -1

          return orderA - orderB
        }

        sortedOptions.sort(compareByLaunchOrder)
      }

      this.filteredOptions = sortedOptions
    },
    selectDeviceWhenOnlyOneOption() {
      if (
        this.filteredOptions.length === 1 &&
        !this.deviceWithoutStock(this.filteredOptions[0])
      ) {
        this.selectNewDevice(this.filteredOptions[0])
      }
    },
    updateDevice() {
      this.showNewDeviceSelector = false
      this.$emit('updateDevice', this.inputValue)
    },
    searchDevice(e) {
      const search = e.target.value.toLowerCase()
      this.filteredOptions = this.searchWithRegex(search, this.adaptedDevices)
    },
    searchWithRegex(search, options) {
      const regex = new RegExp(search, 'i')

      return options.filter((opt) => regex.test(opt.name))
    },
    caseTypes(device) {
      // eslint-disable-next-line camelcase
      return this.$store.state.product.product.case_types.filter((ct) =>
        ct.devices.map((d) => d.device_id).includes(Number(device.id))
      )
    },
    deviceWithoutStock(device) {
      if (!this.product || !this.caseDeviceId) return false
      const caseTypes = this.caseTypes(device)

      const equalSelectedDevice = (d) =>
        // eslint-disable-next-line camelcase
        d.case_device_id === this.caseDeviceId

      const caseType = caseTypes.find((ct) =>
        ct.devices.some(equalSelectedDevice)
      )
      const caseDevice = caseType?.devices?.find(
        // eslint-disable-next-line camelcase
        (dv) => dv.device_id === device.id
        // eslint-disable-next-line camelcase
      )

      return !this.caseDeviceHasStock(caseDevice.case_device_id)
    },
  },
}
</script>

<style lang="scss">
.new-selector-layout__overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 100;
}

.new-selector-layout__selector {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 7px;
  padding: 20px;
  z-index: 101;
  width: 100%;
  max-width: 350px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
}

@media (max-width: 390px) {
  .new-selector-layout__selector {
    max-width: 330px;
  }
}

@media (max-width: 370px) {
  .new-selector-layout__selector {
    max-width: 300px;
  }
}

.new-selector-layout__selector__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 30px;
}

.new-selector-layout__search {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  position: relative;

  .new-selector-layout__search__input {
    flex: 1;
    margin-right: 10px;
    width: 100%;
    border: none;
    height: 40px !important;
    border-bottom: 1px solid #333;
    padding-left: 0px;
  }

  .new-selector-layout__search__icon {
    width: 22px;
    height: 22px;
    position: absolute;
    right: 10px;
    top: 12px;
    color: #999;
  }
}

.new-selector-layout__empty {
  width: 100%;
  background: #f2f2f6;
  color: #333;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  font-size: 15px;
  gap: 10px;
}

.new-selector-layout__empty p {
  margin: 0;
}

.new-selector-layout__selector__body {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 5px;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    height: 100px;
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    height: auto;
    border-radius: 5px;
    background-color: $v4_color_orange;
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
}

@media (max-width: 768px) {
}

.new-selector-layout__list {
  gap: 10px;
}

.new-selector-layout__item {
  padding: 7px;
  display: block;
  width: 100%;
  text-align: center;
  border: 2px solid $v4_color_primary_light;
  border-radius: 5px;
  margin-bottom: 10px;
  font-weight: bold;
  cursor: pointer;
  transition: border-color 0.3s;
}

.new-selector-layout__item:hover {
  border-color: $v4_color_primary;
}

.new-selector-layout__item--active {
  border-color: $v4_color_primary;
}

.new-selector-layout__footer {
  display: flex;
  gap: 10px;
  padding-top: 20px;
}

.new-selector-layout__brands {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  overflow: auto;
  white-space: nowrap;
  margin-left: -15px;
  margin-right: -15px;
  padding: 0px 15px;
}

.new-selector-layoyt__brands--mobile {
  &::-webkit-scrollbar {
    display: none;
  }

  & {
    -ms-overflow-style: none;
  }

  overflow: -moz-scrollbars-none;
}

.new-selector-layout__back,
.new-selector-layout__next,
.new-selector-layout__start,
.new-selector-layout__brands button {
  flex: 1;
  text-align: center;
  padding: 10px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
}

.new-selector-layout__back {
  background-color: #333;
  color: white;
}

.new-selector-layout__next {
  background-color: $v4_color_primary;
  color: white;
}

.new-selector-layout__start,
.new-selector-layout__brands button {
  width: 100%;
  background: #f2f2f6;
  color: #333;
  font-weight: bold;
}

.new-selector-layout__brand--active {
  background-color: $v4_color_primary !important;
  color: white !important;
}

.new-selector-layot__selector__back {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.new-selector-layout__selector__back__link {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #c1c1c1;
}

.new-selector-layout__selector__back__link b {
  margin-left: 10px;
}

.new-selector-layout__selector__back__link svg {
  fill: #c1c1c1;
  width: 17px;
  height: 17px;
}
</style>
